/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module Header
define(
	'Header.View'
,	[
		'SC.Configuration'
	,	'Profile.Model'
	,	'Header.Logo.View'
	,	'Header.MiniCart.View'
	,	'Header.MiniCartSummary.View'
	,	'Header.Profile.View'
	,	'Header.Menu.View'
	,	'GlobalViews.HostSelector.View'
	,	'GlobalViews.CurrencySelector.View'
	,	'ProductList.Utils'

	,	'header.tpl'
	,	'header_sidebar.tpl'

	,	'jQuery'
	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'underscore'
	,	'Utils'
	]
,	function(
		Configuration
	,	ProfileModel
	,	HeaderLogoView
	,	HeaderMiniCartView
	,	HeaderMiniCartSummaryView
	,	HeaderProfileView
	,	HeaderMenuView
	,	GlobalViewsHostSelectorView
	,	GlobalViewsCurrencySelectorView
	,	ProductListUtils

	,	header_tpl
	,	header_sidebar_tpl


	,	jQuery
	,	Backbone
	,	BackboneCompositeView
	,	_
	,	Utils
	)
{
	'use strict';

	// @class Header.View @extends Backbone.View
	return Backbone.View.extend({

		template: header_tpl

	,	events: {
			'click [data-action="show-sitesearch"]': 'showSiteSearch'
		,	'click [data-action="header-sidebar-show"]' : 'showSidebar'
		,	'click [data-action="header-sidebar-hide"]': 'hideSidebar'
		,	'click [data-type="header-sidebar-menu"]': 'hideSidebar'
		,	'click [data-action="changeCustomer"]': 'changeCustomer'
		}

	,	initialize: function ()
		{
			Backbone.history.on('all', this.verifyShowSiteSearch, this);
			
			/*this.productListModule = ProductListUtils(this.options.application);

			this.isProductListEnabled = this.productListModule.isProductListEnabled();

			if (this.isProductListEnabled)
			{
				this.productListsPromise = this.productListModule.getProductListsPromise();

				this.product_list_collection = this.productListModule.getProductLists();
				
				var self = this;

				this.productListsPromise.done(function ()
				{
					var favoriteList = _.find(self.product_list_collection.models,function(model){
						
						return model.get('name') == "Favorites" ? model : undefined ;
						
					});
					
					if(favoriteList)
						self.productListUrl = favoriteList.get('internalid'); 
					self._render();
				});
			}
			else
			{
				this.productListsPromise = jQuery.Deferred();
			}*/

			///Featured Products Slider//
			var self = this;
			jQuery.get( Utils.getAbsoluteUrl('services/FeatureProducts.Service.ss')).done(function(resItems){
			
				jQuery('[data-type="featured-products"]').html('Loading...');
				var idsToBePassed = [];
				_.each(resItems,function(x){
					idsToBePassed.push(x.id);
				})

				var idss = idsToBePassed.join();
				self.collection = [];
				Backbone.ajax({url:"/api/items?id="+idss+"&fieldset=details"
					,	success: function(result){
						
						self.collection=_.sortBy(result.items,function(value){
						{
							return value.custitem_priority_pg;
						}	
						});
							
						var str = '';
						_.each(self.collection,function(item){
							var result = []
							,	item_images_detail = item.itemimages_detail || {};

							item_images_detail = item_images_detail.media || item_images_detail;
							result = Utils.imageFlatten(item_images_detail);

							//@class ImageContainer
							result.length ? result : [{
							//@property {String} url
							url: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', Configuration.get('imageNotAvailable'))
							//@property {String} altimagetext
							,	altimagetext: item.storedisplayname2
							}];
							//str = str + '<li class="item-relations-cell"><a class= "item-relations-related-item-thumbnail" data-touchpoint="home" data-hashtag = "'+item.urlcomponent+'" href="'+item.urlcomponent+'" style="border:none !important"><img src="'+result[0].url+'"/></a><a class="item-relations-related-item-title" data-touchpoint="home" data-hashtag = "'+item.urlcomponent+'" href="'+item.urlcomponent+'" ><span itemprop="name">'+item.storedisplayname2+'</span></a></li>'
							if(_.isEmpty(item.urlcomponent)){
								str = str + '<li class="item-relations-cell"><a class= "item-relations-related-item-thumbnail" data-touchpoint="home" data-hashtag = "product/'+item.internalid+'" style="border:none !important"><img src="'+result[0].url+'"/></a><a class="item-relations-related-item-title" data-touchpoint="home" data-hashtag = "product/'+item.internalid+'"><span itemprop="name">'+item.storedisplayname2+'</span></a></li>'
							}
							else{
								str = str + '<li class="item-relations-cell"><a class= "item-relations-related-item-thumbnail" data-touchpoint="home" data-hashtag="'+item.urlcomponent+'" style="border:none !important"><img src="'+result[0].url+'"/></a><a class="item-relations-related-item-title" data-touchpoint="home" data-hashtag="'+item.urlcomponent+'"><span itemprop="name">'+item.storedisplayname2+'</span></a></li>'
							}
						})
						
						var carousel = self.$('[data-type="featured-products"]');
						
						carousel.html(str);
						
						if (_.isPhoneDevice() === false && self.options.application.getConfig('siteSettings.imagesizes', false)) {
							var img_min_height = _.where(
								self.options.application.getConfig('siteSettings.imagesizes', []),
								{ 
									name: self.options.application.getConfig('imageSizeMapping.thumbnail', '') 
								}
							)[0].maxheight;

							carousel.find('.item-relations-related-item-thumbnail').css('minHeight', img_min_height);
						}

						var slider_options = {
							controls: true,
							pause:10000,
							forceStart:true,
							maxSlides:5,
							minSlides:2,
							nextText:'<a class=\"cms-merchzone-slider-next cms-merchzone-horizontal-control\"><i class=\"carousel-next-arrow\"></i> <span class=\"control-text\">next</span></a>',
							pager:false,
							preloadImages:'all',
							prevText:'<a class=\"cms-merchzone-slider-prev cms-merchzone-horizontal-control\"><i class=\"carousel-prev-arrow\"></i> <span class=\"control-text\">prev</span></a>',
							slideWidth:200,
							touchEnabled:true,
							auto:true,
							autoControls:true
						}
					
					Utils.initBxSlider(carousel, slider_options);
							
					}
				});

		 	})
		}
		
	,	changeCustomer: function()
		{
			var self=this;
			var accNum = Configuration.get('header.accountNumber');
			var url = window.location.href;
			if(url.indexOf("c.4295687") != -1)
			{
				document.cookie = "containsSubCust=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/c."+accNum+"/sca-dev-2018-2;";
				document.cookie = "customerName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/c."+accNum+"/sca-dev-2018-2;";
				document.cookie = "email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/c."+accNum+"/sca-dev-2018-2;";
			}
			else
			{
				document.cookie = "containsSubCust=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/sca-dev-2018-2;";
				document.cookie = "customerName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/sca-dev-2018-2;";
				document.cookie = "email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/sca-dev-2018-2;";
			}
			location.reload();
		
		}
	
		// @method showMiniCart
		//@return {Void}
	,	showMiniCart: function ()
		{
			this.$('[data-type="mini-cart"]').parent().addClass('open');
		}

		// @method showSidebar
		//@return {Void}
	,	showSidebar: function ()
		{
			jQuery('#main').addClass('header-sidebar-opened');
		}

		// @method hideSidebar
		//@return {Void}
	,	hideSidebar: function(e)
		{
			if (e.target.tagName === 'A')
			{
				if(this.activeLink)
				{
					this.activeLink.removeClass('active');
				}
				this.activeLink = jQuery(e.target);
				this.activeLink.addClass('active');
			}
			jQuery('#main').removeClass('header-sidebar-opened');
		}

	,	childViews: {
			'Header.MiniCart': function()
			{
				return new HeaderMiniCartView();
			}
		,	'Header.MiniCartSummary': function()
			{
				return new HeaderMiniCartSummaryView();
			}
		,	'Header.Profile': function()
			{
				var password_protected_site = SC.ENVIRONMENT.siteSettings.siteloginrequired === 'T';
				var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
				if (!password_protected_site || isLoggedIn) {
					var header_profile_view_options = _.extend({
						showMyAccountMenu: true
						,	application: this.options.application
					}, this.options.headerProfileViewOptions || {});
					return new HeaderProfileView(header_profile_view_options);
				} else {
					return null;
				}
			}
		,	'Header.Logo': function()
			{
				return new HeaderLogoView(this.options);
			}
		,	'Header.Menu': function()
			{
				var header_view_options = _.extend(
					{
					application: this.options.application
					}
					, this.options.headerProfileViewOptions || {});

				return new HeaderMenuView(header_view_options);
			}
		,	'Global.HostSelector': function()
			{
				return new GlobalViewsHostSelectorView();
			}
		,	'Global.CurrencySelector': function()
			{
				return new GlobalViewsCurrencySelectorView();
			}
		}

		// @method getContext
		// @return {Header.View.Context}
	,	getContext: function getContext()
		{
			var containsSubCust = $.cookie("containsSubCust");
			var custName = $.cookie("customerName");
			var subCustPage = false;
			if(containsSubCust == 'true')
			{
				subCustPage = true;
			}
			
		//	var favouritesUrl = (SC.ENVIRONMENT.SCTouchpoint == "myaccount"?JSON.parse(SC.ENVIRONMENT.embEndpointUrl).data.domain : SC.ENVIRONMENT.embEndpointUrl.data.domain)+"/Favorites/6";	//gets the domain custom
			var environment = SC.ENVIRONMENT
			,	show_languages = environment.availableHosts && environment.availableHosts.length > 1
			,	show_currencies = environment.availableCurrencies && environment.availableCurrencies.length > 1 && !Configuration.get('header.notShowCurrencySelector');
			
			var profile = ProfileModel.getInstance()
			,	is_loading = !_.getPathFromObject(Configuration, 'performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
			,	is_logged_in = (profile.get('isLoggedIn') === 'T' || profile.get('isRecognized') === 'T') && profile.get('isGuest') === 'F';
			
			var logOutUrl = SC.SESSION.touchpoints.logout;
				logOutUrl += logOutUrl.replace(/logOut/gi, "logOut_custom");
				logOutUrl += '&lang=en_US&lang=en_US';
			
			var customFlds = profile.get('customfields');
			var isSubCust = 'F';
			var isIvaluaPunchout = '';
			if(customFlds.length > 0)
			{
				for(var i=0; i < customFlds.length; i++)
				{
					if(customFlds[i].name == "custentity_appf_is_sub_customer")
						isSubCust = customFlds[i].value;
					if(customFlds[i].name == "custentity_appf_ivalua_punchout")
						isIvaluaPunchout = customFlds[i].value;
						
				}					
			}
			
			
			///initialize code for lists cloned here 
			this.productListModule = ProductListUtils(this.options.application);

			this.isProductListEnabled = this.productListModule.isProductListEnabled();

			if (this.isProductListEnabled)
			{
				this.productListsPromise = this.productListModule.getProductListsPromise();

				this.product_list_collection = this.productListModule.getProductLists();
				
				var self = this;

				this.productListsPromise.done(function ()
				{
					var favoriteList = _.find(self.product_list_collection.models,function(model){
						
						return model.get('name') == "Favorites" ? model : undefined ;
						
					});
					
					if(favoriteList)
						self.productListUrl = favoriteList.get('internalid'); 
				});
			}
			else
			{
				this.productListsPromise = jQuery.Deferred();
			}

			// @class Header.View.Context
			return {
				
				showLoginMenu: !is_loading && !is_logged_in
	
				// @property {Profile.Model} profileModel
			,	profileModel: ProfileModel.getInstance()
				// @property {Boolean} showLanguages
			,	showLanguages: show_languages
				// @property {Boolean} showCurrencies
			,	showCurrencies: show_currencies
				// @property {Boolean} showLanguagesOrCurrencies
			,	showLanguagesOrCurrencies: show_languages || show_currencies
				// @property {Boolean} showLanguagesAndCurrencies
			,	showLanguagesAndCurrencies: show_languages && show_currencies
				// @property {Boolean} isHomeTouchpoint
			,	isHomeTouchpoint: Configuration.currentTouchpoint === 'home'
				// @property {String} cartTouchPoint
			,	cartTouchPoint: Configuration.get('modulesConfig.Cart.startRouter', false) ? Configuration.currentTouchpoint : 'viewcart'
						
			,	productListUrl: this.productListUrl  //,	favouritesUrl: favouritesUrl
			
			, 	isMobile:screen.width<768?true:false
			
			,	subCustPage:subCustPage
			,	custName:custName
			,	isChangeExist: (isSubCust == 'T' && isIvaluaPunchout == '')?true : false
			,	changeUserUrl: Configuration.get('header.changeUserURL') || logOutUrl
			,	isIvaluaLogin: (isIvaluaPunchout == '')? false : true
			
			};
			// @class Header.View
		}

		//@method destroy Override default destroy method to clean navigation event handlers
		//@return {Void}
	,	destroy: function ()
		{
			Backbone.View.prototype.destroy.apply(this, arguments);

			Backbone.history.off('all', this.verifyShowSiteSearch);
		}
	});

});

